import requester from '@zg-rentals/particles-js-requester';
import requestWrapper from '@common/utils/requestWrapper';
import AppConstants from '@common/constants/AppConstants';
import type { GetUserInterface } from '../types';
import StringConstants from '@common/constants/StringConstants';
import { getGlobalLogger } from '@zg-rentals/logger-base';

const GET = StringConstants.API.VERBS.GET;

function getBaseApi(appName: string): string {
  if (appName === AppConstants.RENTER_HUB) {
    return __BROWSER__ ? '/renter-hub/payments/proxy/renter-hub-api' : '/renter-hub-api';
  }
  return __BROWSER__ ? '/rental-manager/payments/proxy/rental-manager-api' : '/rental-manager-api';
}

function getServerApiBase(appName: string): string {
  if (appName === AppConstants.RENTER_HUB) {
    return process.env.RENTER_HUB_API || '';
  }
  return process.env.RENTAL_MANAGER_API || '';
}

function getClient(appName: string) {
  return requester({
    api: typeof window === 'undefined' ? getServerApiBase(appName) : '',
    logger: getGlobalLogger('requester'),
  });
}

const api = {
  users: {
    getUser({ appName = AppConstants.RENTAL_MANAGER, pageWithSensitiveInformation = false }: GetUserInterface) {
      const baseApi = getBaseApi(appName);
      const isRenterHub = appName === AppConstants.RENTER_HUB;
      const endpoint = isRenterHub ? `${baseApi}/api/v1/users/get` : `${baseApi}/api/web/v2/users/get`;
      return requestWrapper(getClient(appName), GET, endpoint, {
        params: {
          pageWithSensitiveInformation,
          // v1 (renter-hub) supports includeSummary; v2 always returns summary.
          ...(isRenterHub && { includeSummary: true }),
        },
      });
    },
    experiments: {
      getTreatment({ featureName, appName = AppConstants.RENTAL_MANAGER }: { featureName: string; appName: string }) {
        const baseApi = getBaseApi(appName);
        const endpoint = `${baseApi}/api/v1/users/experiments/getTreatment`;
        return requestWrapper(getClient(appName), GET, endpoint, {
          params: {
            featureName,
          },
        });
      },
    },
  },
};

export default api;
